import React, { useState } from "react"
import Email from "../common/Email"

const StartYourTomorrow = () => (
  <div className="w-full bg-gray-800 py-24">
    <div className="max-w-page text-white text-center px-10">
      <h2 className="text-5xl font-extrabold mx-auto">
        Start your <span className="text-primary-txt">tomo</span>rrow<span className="text-primary-txt">.</span>
      </h2>
      <p className="max-w-xl mx-auto my-6 text-lg tracking-wide">
        Our approval process is quick, easy, and won't impact your credit score.
        See if you are eligible today.
      </p>
      <div className="max-w-xl mx-auto mt-12">
        <Email />
      </div>
    </div>
  </div>
);

export default StartYourTomorrow;
